import Api from './baseApi';

export default {
  getUpcomingPlan: (params) => Api.get('/api/mintAgreements/upcoming-plan', { params }),
  getNotifications: (daysAhead = 1) => Api.get('/api/mintAgreements/notifications', { params: { daysAhead } }),
  getList: (params) => Api.get('/api/mintAgreements', { params }),
  get: (id) => Api.get(`/api/mintAgreements/${id}`),
  create: (payload) => Api.post('/api/mintAgreements', payload),
  update: (id, payload) => Api.put(`/api/mintAgreements/${id}`, payload),
  markPaid: (id, paidAt, cashAccountId) => Api.put(`/api/mintAgreements/${id}/mark-paid`, { paidAt, cashAccountId }),
  partialPay: (id, payload) => Api.post(`/api/mintAgreements/${id}/partial-pay`, payload),
  getChain: (id) => Api.get(`/api/mintAgreements/${id}/chain`),
  cancel: (id) => Api.delete(`/api/mintAgreements/${id}`),
};
